import { ReactNode } from 'react';

import { EventsModalType } from '../enums/events-modal-type.const';
import { GetMoreEnvelopesModal } from '../modals/get-more-envelops-modal';

export type EventsModalTypeComponentMap = Record<EventsModalType, ReactNode>;

export const eventsModalTypeComponentMap: EventsModalTypeComponentMap = {
  [EventsModalType.GET_MORE_ENVELOPES]: <GetMoreEnvelopesModal />,
  [EventsModalType.REVIEW_DOCUMENTS]: null,
};
